import VideoManager from './VideoManager'

export default new VideoManager()
